<template>
  <div >
    <b-container>
      <b-row align-v="center" align-h="start">
        <b-col sm="auto">
          <b-input placeholder="Filter tags"  v-model="tagFilter"></b-input>
        </b-col>
        <b-col  sm="auto">
          <b-dropdown class="m-md-2" :text="activeHorse || 'Select Horse'">
            <b-dropdown-item v-for="horse in race.horses" @click="activeHorse = horse.name">{{horse.name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col  sm="auto">
          <b-dropdown class="m-md-2" :text="activeTagType || 'Select Tag Type'">
            <b-dropdown-item v-for="tagType in tagTypes" @click="activeTagType = tagType">{{tagType}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
    </b-container>
    <table class="table">
      <thead >
        <tr>
          <th scope="col">Tag</th>
          <th v-for="raceProperty in race.report.raceProperties">{{raceProperty}}</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tag in filteredList" :style="tag.data.aboveAverage? 'font-weight:bold' :''">
          <td :id="tag.tag">
            {{tag.tag}}
            <b-tooltip  :target="tag.tag">
              {{tag.horses.join(", ")}}
            </b-tooltip>
          </td>
          <td v-for="raceProperty in race.report.raceProperties" :id="tag.tag + '.' + raceProperty" >
            {{getScore(tag, raceProperty,'netScore')}}
            <b-tooltip :target="tag.tag + '.' + raceProperty">
              {{getScore(tag, raceProperty,'count')}}
            </b-tooltip>
          </td>
          <td>{{tag.data.netScore.toFixed(3)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TagTable',
  props:   ['race'],
  components: {
  },
  data () {
    return {
      title: 'TagTable',
      tagFilter: undefined,
      filteredList: [],
      activeHorse: undefined,
      tagTypes: [],
      activeTagType: undefined
    }
  },
  watch: {
    tagFilter: function () {
      this.filteredList = this.race.report.tagArray.filter(obj => obj.tag.indexOf(this.tagFilter) > -1)
    },
    activeHorse: function () {
      this.filteredList = this.race.report.tagArray.filter(obj => obj.horses.indexOf(this.activeHorse) > -1)
    },
    activeTagType: function () {
      this.filteredList = this.race.report.tagArray.filter(obj => obj.tag.indexOf(this.activeTagType) > -1)
    }
  },
  methods: {
    getScore: function (tag, raceProperty, scoreType) {
      if (tag.data.scoresUsed === 0) {
        return 0
      }else {
        if (tag.data.raceProperties[raceProperty] && tag.data.raceProperties[raceProperty][this.race[raceProperty]][scoreType]) {
          return 1 * tag.data.raceProperties[raceProperty][this.race[raceProperty]][scoreType].toFixed(3)
        }else {
          return 0
        }
      }
    }
  },
  mounted () {
    this.filteredList = this.race.report.tagArray
    this.tagTypes = []
    this.race.report.tagArray.forEach(tagObj => {
      var tagType = tagObj.tag.substr(0,3)
      if (this.tagTypes.indexOf(tagType) === -1) this.tagTypes.push(tagType)
    })
    this.tagTypes.sort((a,b) => a-b)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dropdown-bb {
  color:white
}
</style>
